import { theme } from 'antd';
import { formatDisplayName } from 'library/helpers/utility';
import { useSelector } from 'react-redux';
import { selectDependantPeopleByPersonID } from 'reduxStore/people/selectors';
import { Loader } from 'zComponents/atoms';
import { Empty, Flex, Tag } from 'zui/Antd';
import PersonDrawer from '../..';
import { useState } from 'react';
import { UserIcon } from 'assets/images/svg';

const DependantPanelContent = ({ personID }) => {
	const {
		token: { fontWeightStrong, paddingXXS, paddingSM }
	} = theme.useToken();

	const [selectedPersonID, setSelectedPersonID] = useState(null);
	const [openPeopleDrawer, setOpenPeopleDrawer] = useState(false);
	// ✅ Redux state
	const dependantPeople = useSelector((state) => selectDependantPeopleByPersonID(state, personID));
	const { loadingUpdateProfile } = useSelector((state) => state.People);

	return (
		<Flex wrap gap={paddingSM}>
			{loadingUpdateProfile ? (
				<Flex justify='center' style={{ width: '100%' }}>
					<Loader />
				</Flex>
			) : dependantPeople.length === 0 ? (
				<div
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center'
					}}
				>
					<Empty description='No associated people' image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</div>
			) : (
				dependantPeople.map((person) => (
					<Tag
						key={person.personID}
						color='purple'
						style={{
							fontWeight: fontWeightStrong,
							borderColor: 'currentColor',
							cursor: 'pointer',
							marginInlineEnd: 0
						}}
						onClick={() => {
							setSelectedPersonID(person.personID);
							setOpenPeopleDrawer(true);
						}}
					>
						<Flex align='center' gap={paddingXXS}>
							<UserIcon color='currentColor' />
							{formatDisplayName(person)?.displayName || `${person.firstName} ${person.lastName}`}
						</Flex>
					</Tag>
				))
			)}
			<PersonDrawer visible={openPeopleDrawer} setVisible={setOpenPeopleDrawer} personID={selectedPersonID} />
		</Flex>
	);
};

export default DependantPanelContent;
